var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appc-icon",style:('height:' + _vm.height +';width:'+_vm.width+';max-height:' + _vm.height +';max-width:'+_vm.width+';fill:'+_vm.dynamicColor)},[_c(_vm.dynamicIcon,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }